import React from 'react';
import LayoutMain from './components/Layout/layout.main';
import Routing from './routes';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ConnectedRouter } from 'connected-react-router';
import configureStore, { history } from './store/config';
import ReactGA from 'react-ga';

const { store, persistor } = configureStore();
ReactGA.initialize('UA-157146270-1');

// Initialize google analytics page view tracking
history.listen(location => {
    ReactGA.set({ page: location.pathname }); // Update the user's current page
    ReactGA.pageview(location.pathname); // Record a pageview for the given page
});

function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ConnectedRouter history={history}>
                    <LayoutMain>
                        <Routing />
                    </LayoutMain>
                </ConnectedRouter>
            </PersistGate>
        </Provider>
    );
}

export default App;
